import { makeObservable } from 'mobx'

import { SystemFieldEnum } from '../constants/fields'
import FieldsStore from '../store/FieldsStore'
import { ContactTemplateType, Template } from '../types'
import { UnionFieldModelType } from '../types/Field'
import RecordUtils from '../utils/RecordUtils'

import TemplateModel from './TemplateModel'
import { Collection } from './Collection'
import { AssigneeFieldMapping } from '../types/Field/field'

class ContactTemplateModel extends TemplateModel {
   private assigneeFieldsMap: Collection<string, string>

   private _identificationFieldIds!: Array<string>

   private constructor(
      contactTemplate: ContactTemplateType,
      fieldsStore: FieldsStore
   ) {
      super(contactTemplate.templateId, contactTemplate.name ?? '', fieldsStore)

      this.update(contactTemplate)
      this.assigneeFieldsMap = new Collection<string, string>(
         'The AssigneeField you are trying to access does not exist'
      )
      this.setAssigneeFieldsMap(contactTemplate.assigneeFieldsMapping)
      this.setIdentificationFieldIds(contactTemplate.identificationFieldIds)

      makeObservable(this, {})
   }

   get assigneeFields(): UnionFieldModelType[] {
      const fieldModels = this.fields.filter(
         field => field.systemFieldEnum === SystemFieldEnum.ContactAssignee
      )

      return fieldModels
   }

   get phoneNumberFields(): UnionFieldModelType[] {
      const fieldModels = this.fields.filter(
         field => field.fieldType === 'PHONE_NUMBER'
      )

      return fieldModels
   }

   get identificationFields(): Array<UnionFieldModelType> {
      return this._identificationFieldIds.map(eachFieldId =>
         this.getField(eachFieldId)
      )
   }

   setIdentificationFieldIds(fieldIds: Array<string>) {
      this._identificationFieldIds = fieldIds
   }

   setAssigneeFieldsMap(assigneeFieldsMapping: AssigneeFieldMapping[]) {
      this.assigneeFieldsMap.clearData()

      assigneeFieldsMapping.forEach(
         ({ assigneeFieldId, assignedOnFieldId }) => {
            this.assigneeFieldsMap.addItem(assigneeFieldId, assignedOnFieldId)
         }
      )
   }

   getAssignedOnFieldId = (assigneeFieldId: string): string =>
      this.assigneeFieldsMap.getItem(assigneeFieldId)

   hasAssignedOnFieldId = (assigneeFieldId: string): boolean =>
      this.assigneeFieldsMap.hasItem(assigneeFieldId)

   update = (template: Template): void => {
      RecordUtils.updateTemplateModel(this, template)
   }

   static createContactTemplateModel = (
      contactTemplate: ContactTemplateType,
      fieldsStore: FieldsStore
   ): ContactTemplateModel =>
      new ContactTemplateModel(contactTemplate, fieldsStore)
}

export default ContactTemplateModel
